import { render, staticRenderFns } from "./mapLegend.vue?vue&type=template&id=35d5e903&scoped=true&"
import script from "./mapLegend.vue?vue&type=script&lang=js&"
export * from "./mapLegend.vue?vue&type=script&lang=js&"
import style0 from "./mapLegend.vue?vue&type=style&index=0&id=35d5e903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d5e903",
  null
  
)

export default component.exports